import { useEffect } from "react";
import { PitSelector } from "src/business-components/input/PitSelector/PitSelector";
import { ALL_TASKS } from "src/business-components/input/TaskSelector/TaskSelector.constants";
import { useGetTaskPits } from "src/business-components/pipeline/PipelinePitSelector/PipelinePitSelector.hooks";
import { TIME_WINDOW_ALL_TIME } from "src/components/features/medium/AssetsFilter/components/TimeWindow/TimeWindow.constants";
import { parseTask } from "../ComparativeAnalysisFormTask/ComparativeAnalysisFormTask.utils";

interface ComparativeAnalysisFormPitProps {
  env: string;
  pipelineName: string;
  pipelineId: string;
  pit?: string;
  task?: string;
  disabled?: boolean;
  onChange: (pit: string) => void;
  setIsValidValue: (isValid: boolean) => void;
  isLoading?: boolean;
}

const ComparativeAnalysisFormPit = ({
  env,
  pipelineName,
  pipelineId,
  pit,
  task,
  disabled,
  onChange,
  setIsValidValue,
  isLoading,
}: ComparativeAnalysisFormPitProps) => {
  const [task_name = ""] = parseTask(task);

  const { filteredPits: pits, isLoading: isLoadingPits } = useGetTaskPits({
    body: {
      env_name: env,
      app_name: pipelineName,
      app_id: pipelineId,
      ...(task_name !== ALL_TASKS && { task_name }),
      timeWindow: TIME_WINDOW_ALL_TIME,
    },
    options: {
      enabled: !disabled,
    },
  });

  // const {
  //   data: pits,
  //   isFetching,
  //   isFetched,
  // } = useQueryRuns({
  //   params: {
  //     body: { app_id: pipelineId, timeWindow: -1 },
  //   },
  //   options: {
  //     enabled: !disabled,
  //   },
  // });

  isLoading ||= isLoadingPits;

  // make sure the `pit` prop (derrived from URL query-param) exists in the pits list
  useEffect(() => {
    // check if the current selected "pit" (value) exists in the list of pits from the API
    if (pits.length && !disabled) {
      const isValidPit = pits?.some((p) => p.app_pit === pit);

      setIsValidValue(isValidPit ?? false);
    }
  }, [setIsValidValue, pits, pit, disabled]);

  return (
    <PitSelector
      pit={pit}
      pits={pits}
      withReruns
      disabled={disabled}
      onChange={onChange}
      isLoading={isLoading}
    />
  );
};

export default ComparativeAnalysisFormPit;
